import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Breadcrumb from "../components/Breadcrumb/Breadcrumb";
import Aside from "../components/Aside/Aside";

import navRoutesTeacher from "../Routes/navRoutesTeacher";
import navRoutesSuperuser from "../Routes/navRoutesSuperuser";
import navRoutesStudent from "../Routes/navRoutesStudent";

class Main extends Component {
  render() {
    const { auth } = this.props;
    var roles = auth.auth.roles;
    let displaySideBar = true;
    let navRoutes = [];

    switch (roles) {
      case "Student":
        navRoutes = navRoutesStudent;
        displaySideBar = true;
        break;
      case "Teacher":
        navRoutes = navRoutesTeacher;
        displaySideBar = true;
        break;
      case "Superuser":
      case "Admin":
        navRoutes = navRoutesSuperuser;
        break;
      default:
        break;
    }

    return (
      <div className="app">
        <Header />
        <div className={"app-body"}>
          {displaySideBar && <Sidebar {...this.props} />}

          <main className="main">
           {/*  <NewBreadcrumb match = {this.props.match}/> */}
            <Breadcrumb />
            <Container fluid>
              <Switch>
                {navRoutes.map((route, idx) => {
                  return route.component ? (
                    <Route
                      key={idx}
                      path={route.path}
                      exact={route.exact}
                      name={route.name}
                      data={route.props}
                      render={props => <route.component data={route.props} {...props} />}
                    />
                  ) : null;
                })}
                {/* <Redirect from="/" to="/superdash" /> */}
              </Switch>
            </Container>
          </main>
          <Aside />
        </div>
        {/* <Footer /> */}
      </div>
    );
  }
}

const mapStateToProps = store => {
  return {
    auth: store.auth
  };
};

export default connect(mapStateToProps)(Main);
